
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"116.798","height":"50"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(-58.202 -374.058)"}},[_c('path',{attrs:{"d":"M106.252 382.7h-11v-8.642l-37.05 6.121v39.273l37.05 4.606v-7.122h11zm-2.424 31.811h-8.577v-3.874h3.345v-2.424h-3.345v-3.983h3.345v-2.424h-3.345v-3.981h3.345v-2.424h-3.345v-3.976h3.345v-2.424h-3.345v-3.876h8.577z","fill":"#a5a5a5"}}),_c('path',{attrs:{"d":"M65.932 389.759h4.089l1.219 8.261c.217 1.84.488 3.709.7 5.576h.108c.352-1.867.7-3.736 1.057-5.576l1.894-8.261h3.384l1.9 8.261c.352 1.786.7 3.682 1.057 5.576h.108c.244-1.894.488-3.763.732-5.576l1.219-8.261h3.818l-3.14 17.655h-5.015l-1.731-8.015c-.3-1.355-.515-2.791-.7-4.089h-.108c-.217 1.3-.434 2.734-.731 4.089l-1.65 8.015h-4.931z","fill":"#fff"}}),_c('circle',{attrs:{"fill":"#a5a5a5","cx":"2","cy":"2","r":"2","transform":"translate(115 397)"}}),_c('circle',{attrs:{"fill":"#a5a5a5","cx":"2","cy":"2","r":"2","transform":"translate(123 397)"}}),_c('circle',{attrs:{"fill":"#a5a5a5","cx":"2","cy":"2","r":"2","transform":"translate(131 397)"}}),_c('circle',{attrs:{"fill":"#a5a5a5","cx":"2","cy":"2","r":"2","transform":"translate(139 397)"}}),_c('g',[_c('path',{attrs:{"d":"M163 386a12 12 0 11-12 12 12 12 0 0112-12z","fill":"#378500"}}),_c('path',{attrs:{"d":"M157.493 398.462l2.991 3.16 8.271-6.983","fill":"none","stroke":"#fff","stroke-width":"2"}})])])])
          )
        }
      }
    